/**
 * Fixes Recharts ResponsiveContainer dimensions for screenshot capture.
 * This function is specific to Recharts and should not be used in the generic useScreenshot hook.
 */
export const fixResponsiveContainerDimensions = (element: HTMLElement) => {
  const responsiveContainers = element.querySelectorAll(
    ".recharts-responsive-container",
  );

  responsiveContainers.forEach((container) => {
    const containerEl = container as HTMLElement;

    const width = containerEl.offsetWidth || containerEl.clientWidth;
    const height = containerEl.offsetHeight || containerEl.clientHeight;

    if (width > 0 && height > 0) {
      const svg = containerEl.querySelector("svg");

      if (svg) {
        svg.setAttribute("width", width.toString());
        svg.setAttribute("height", height.toString());
        svg.style.width = `${width}px`;
        svg.style.height = `${height}px`;

        containerEl.style.width = `${width}px`;
        containerEl.style.height = `${height}px`;
      }
    }
  });

  // Also handle any standalone SVG elements that might be from charts
  const allSvgs = element.querySelectorAll("svg");

  allSvgs.forEach((svg) => {
    const svgEl = svg as SVGSVGElement;
    const parent = svgEl.parentElement;

    if (parent) {
      const parentWidth = parent.offsetWidth || parent.clientWidth;
      const parentHeight = parent.offsetHeight || parent.clientHeight;

      // Only set dimensions if SVG doesn't already have them and parent has dimensions
      if (
        parentWidth > 0 &&
        parentHeight > 0 &&
        (!svgEl.getAttribute("width") || !svgEl.getAttribute("height"))
      ) {
        // For charts with aspect ratios, preserve them
        const computedStyle = window.getComputedStyle(parent);

        if (computedStyle.aspectRatio) {
          const aspectRatio = parseFloat(computedStyle.aspectRatio);

          if (aspectRatio && !isNaN(aspectRatio)) {
            const calculatedHeight = parentWidth / aspectRatio;
            svgEl.setAttribute("width", parentWidth.toString());
            svgEl.setAttribute("height", calculatedHeight.toString());
            svgEl.style.width = `${parentWidth}px`;
            svgEl.style.height = `${calculatedHeight}px`;
          }
        } else {
          svgEl.setAttribute("width", parentWidth.toString());
          svgEl.setAttribute("height", parentHeight.toString());
          svgEl.style.width = `${parentWidth}px`;
          svgEl.style.height = `${parentHeight}px`;
        }
      }
    }
  });
};
